import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import '../styles/Scoreboard.css';

const Scoreboard = () => {
    const [scoreboard, setScoreboard] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userName = Cookies.get('bbq_user_name');

    useEffect(() => {
        const fetchScoreboard = async () => {
            try {
                setLoading(true);
                const response = await fetch('/api/raffle/scoreboard');
                
                if (response.ok) {
                    const data = await response.json();
                    setScoreboard(data.allTimeScoreboard);
                } else {
                    const errorData = await response.json();
                    setError(errorData.error || 'Failed to fetch results');
                }
            } catch (err) {
                console.error('Failed to fetch results:', err);
                setError('Failed to fetch results data');
            } finally {
                setLoading(false);
            }
        };

        fetchScoreboard();
        // Poll for updates every 10 seconds
        const interval = setInterval(fetchScoreboard, 10000);
        
        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return (
            <div className="scoreboard-container">
                <h3>Results</h3>
                <div className="loading-indicator">Loading results...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="scoreboard-container">
                <h3>Results</h3>
                <div className="error-message">{error}</div>
            </div>
        );
    }

    return (
        <div className="scoreboard-container">
            <h3>Results</h3>
            
            {scoreboard.length === 0 ? (
                <p className="no-data-message">No challenges completed yet. Be the first!</p>
            ) : (
                <div className="scoreboard-table-container">
                    <table className="scoreboard-table">
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Name</th>
                                <th>Completed</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scoreboard.map((entry, index) => (
                                <tr 
                                    key={entry.member_name} 
                                    className={entry.member_name === userName ? 'current-user-row' : ''}
                                >
                                    <td className="rank-cell">
                                        {index === 0 && <span className="rank-badge gold">🥇</span>}
                                        {index === 1 && <span className="rank-badge silver">🥈</span>}
                                        {index === 2 && <span className="rank-badge bronze">🥉</span>}
                                        {index > 2 && <span className="rank-number">{index + 1}</span>}
                                    </td>
                                    <td className="name-cell">
                                        {entry.member_name}
                                        {entry.member_name === userName && <span className="you-indicator"> (You)</span>}
                                    </td>
                                    <td className="score-cell">{entry.completed_count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Scoreboard; 